export class GeoAddressComponent {
    long_name: string;
    short_name: string;
    types: string[];
}

export class GeoNortheast {
    lat: number;
    lng: number;
}

export class GeoSouthwest {
    lat: number;
    lng: number;
}

export class GeoBounds {
    northeast: GeoNortheast;
    southwest: GeoSouthwest;
}

export class GeoLocation {
    lat: number;
    lng: number;
}

export class GeoViewport {
    northeast: GeoNortheast;
    southwest: GeoSouthwest;
}

export class GeoGeometry {
    bounds: GeoBounds;
    location: GeoLocation;
    location_type: string;
    viewport: GeoViewport;
}

export interface GeoPhoto {
    height: number;
    html_attributions: string[];
    width: number;
}


// WEBPACK FOOTER //
// ./src/angular_library/models/google-geo-classes.ts